import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as FacebookSvg } from './facebook.svg';
import { ReactComponent as InstagramSvg } from './instagram.svg';
import { ReactComponent as LinkedinSvg } from './linkedin.svg';
import { ReactComponent as TelegramSvg } from './telegram.svg';
import { ReactComponent as TwitterSvg } from './twitter.svg';

export const FacebookIcon: FC<SvgIconProps> = forwardRef((props, ref) => <FacebookSvg ref={ref} {...props} />);
export const InstagramIcon: FC<SvgIconProps> = forwardRef((props, ref) => <InstagramSvg ref={ref} {...props} />);
export const LinkedinIcon: FC<SvgIconProps> = forwardRef((props, ref) => <LinkedinSvg ref={ref} {...props} />);
export const TelegramIcon: FC<SvgIconProps> = forwardRef((props, ref) => <TelegramSvg ref={ref} {...props} />);
export const TwitterIcon: FC<SvgIconProps> = forwardRef((props, ref) => <TwitterSvg ref={ref} {...props} />);
